<template>
  <section class="home">
    <van-pull-refresh v-model="isLoading" @refresh="refreshPage">

      <!-- <section class="promise">
        <ul>
          <li>
            <img src="~@cdn_img/icon-40.svg" alt="">
            <p>私人订制</p>
          </li>
          <li>
            <img src="~@cdn_img/icon-41.svg" alt="">
            <p>超低价格</p>
          </li>
          <li>
            <img src="~@cdn_img/icon-42.svg" alt="">
            <p>优质服务</p>
          </li>
          <li>
            <img src="~@cdn_img/icon-43.svg" alt="">
            <p>唱吧严选</p>
          </li>
        </ul>
      </section> -->

      <section class="banner">
        <mall-banner :data="detail.banner">
          <template #default="{ item, index }">
            <a href="javascript:;" @click="gotoUrl(item.url)" v-cbs="`banner-${index + 1}`">
              <img :src="item.poster | replaceUrlProtocol" alt="">
            </a>
          </template>
        </mall-banner>
      </section>

      <section class="channels" v-if="detail.btn && detail.btn.length > 0">
        <ul>
          <li v-for="(item, index) in detail.btn" :key="index">
            <a href="javascript:;" @click="gotoUrl(item.url)" v-cbs="`channel-${index + 1}`">
              <img :src="item.poster">
              <p>{{ item.title }}</p>
            </a>
          </li>
        </ul>
      </section>

      <section class="topics" v-if="detail.full_banner && detail.full_banner.length > 0">
        <van-swipe autoplay="5000" indicator-color="#fff" width="100%">
          <van-swipe-item v-for="(item, index) in detail.full_banner" :key="index">
            <a href="javascript:;" @click="gotoUrl(item.url)" v-cbs="`full-banner-${index + 1}`">
              <img :src="item.poster | replaceUrlProtocol" alt="">
            </a>
          </van-swipe-item>
        </van-swipe>
      </section>

      <section class="page-section post-production" v-if="detail.disc_tab && detail.disc_tab.length > 0">
        <h2>
          <a href="javascript:;" @click="gotoUrl('/njwap/chanpin/mall/index/main/homes/post-production')" v-cbs="`首页-人工修音模块-更多`">
            人工修音
            <small class="arrow-right">更多</small>
          </a>
        </h2>
        <ul>
          <li v-for="(item, index) in detail.disc_tab" :key="index">
            <button type="button" :class="{ active: postProductionIndex === index }" @click="changePostProduction(index)" v-cbs="`首页-人工修音模块-tab-${item.name}`">
              {{ item.name }}
            </button>
          </li>
        </ul>
        <div class="music-player">
          <van-swipe autoplay="0" :show-indicators="false" :touchable="false" :loop="false" ref="board">
            <van-swipe-item v-for="(item, index) in detail.disc_tab" :key="index" :class="{ active: postProductionIndex === index }">
              <div class="music-item">
                <div class="hd">
                  <mall-disc-button
                    class="player-button"
                    theme="1"
                    :active="postPlayingIndex === index"
                    :gold="item.gold"
                    :img="item.pic"
                    :needle="true"
                    @click="handlePostProductionPlay(index, item.audio)"
                    v-cbs="`首页-人工修音模块-播放-${item.name}`"
                  />
                </div>
                <div class="bd">
                  <h3>{{ item.title }}</h3>
                  <p class="desc">
                    <span v-for="(value, key) in item.service.split(/\n/)" :key="key">{{ value }}</span>
                  </p>
                  <p class="money" v-if="item.info.id">
                    <template v-if="item.info.service_class == 1 && item.info.type == 3">
                      <strong>¥{{ item.info.deposit_money }}</strong>
                    </template>
                    <template v-else>
                      <template v-if="item.info.activity_money_info.type">
                        <strong>¥{{ item.info.activity_money_info.activity_money }}</strong><small>¥{{ item.info.now_money }}</small>
                      </template>
                      <template v-else>
                        <strong>¥{{ item.info.now_money }}</strong>
                      </template>
                    </template>
                    {{ item.desc }}
                  </p>
                </div>
                <div class="ft">
                  <button type="button" class="btn" @click="gotoUrl(`/njwap/chanpin/mall/index/main/product/${item.id}`)" v-cbs="`首页-人工修音模块-去制作-${item.name}`">去制作</button>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </section>

      <section class="page-section music-market" v-if="detail.market_song && detail.market_song.length > 0">
        <h2>
          <a href="javascript:;" @click="gotoUrl('/njwap/chanpin/music-market/index/main')" v-cbs="`首页-原创音乐模块-更多`">
            原创音乐
            <small class="arrow-right">更多</small>
          </a>
        </h2>
        <ul>
          <li v-for="(item, index) in detail.market_song" :key="item.songid">
            <div class="market-item">
              <div class="hd">
                <mall-disc-button
                  class="player-button"
                  theme="2"
                  :active="marketPlayingIndex === index"
                  :img="item.icon"
                  :lazy="true"
                  :lace="false"
                  @click="handlePlay(index, item.mp3)"
                  v-cbs="`首页-原创音乐模块-播放-${item.name}`"
                />
              </div>
              <div class="bd">
                <h3><span>{{ item.name }}</span></h3>
                <p class="author">{{ item.seller_name }}</p>
                <p class="time">{{ item.music_duration | formatTime }}</p>
                <p class="money"><strong>¥{{ item.price }}</strong></p>
              </div>
              <div class="ft">
                <button type="button" class="btn" @click="gotoUrl(`/njwap/chanpin/music-market/index/main#/lyric/${item.songid}`)" v-cbs="`首页-原创音乐模块-去购买-${item.name}`">
                  去购买
                </button>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <!-- <section class="page-section education" v-if="detail.teach && detail.teach.length > 0">
        <h2>
          <a href="javascript:;" @click="gotoUrl('/njwap/chanpin/mall/index/main/homes/education')" v-cbs="`首页-音乐教学模块-更多`">
            音乐教学
            <small class="arrow-right">更多</small>
          </a>
        </h2>
        <ul>
          <li class="product-item" v-for="item in detail.teach" :key="item.id">
            <a href="javascript:;" @click="gotoUrl(`/njwap/chanpin/mall/index/main/product/${item.id}`)" v-cbs="`首页-音乐教学模块-${item.name}`">
              <img :data-src="item.icon | replaceUrlProtocol" class="lazyload" :alt="item.name">
              <h3><span>{{ item.name }}</span></h3>
              <p><span>{{ item.subtitle }}</span></p>
              <div class="money">
                <template v-if="typeof item.activity_money === 'number'">
                  <template v-if="item.type === 'vip'">
                    ¥{{ item.now_money }}<span class="vip">¥{{ item.activity_money }}</span>
                  </template>
                  <template v-else>
                    ¥{{ item.activity_money }}<span>¥{{ item.now_money }}</span>
                  </template>
                </template>
                <template v-else>
                  ¥{{ item.now_money }}
                </template>
              </div>
            </a>
          </li>
        </ul>
      </section> -->

      <section class="page-section mercury">
        <h2>
          <a href="javascript:;" @click="gotoUrl('/njwap/chanpin/mall/index/main/homes/mercury')" v-cbs="`首页-全网发行-更多`">
            全网发行
            <small class="arrow-right">更多</small>
          </a>
        </h2>
        <div class="bd">
          <a href="javascript:;" @click="gotoUrl('/njwap/chanpin/mall/index/main/homes/mercury')" v-cbs="`首页-全网发行-Banner`">
            <img data-src="//res.cdn.changbaimg.com/-/ebf88aa1a33cdce1/1.jpg" class="lazyload" alt="">
          </a>
        </div>
      </section>

      <mall-float-navigator ref="navigator" />

      <audio :src="playerSource | replaceUrlProtocol" ref="player" @pause="stop" @ended="stop" @error="stop" v-if="playerSource"></audio>

    </van-pull-refresh>

    <mall-notice-dialog v-model="showNotice" @close="closeNotice" />
  </section>
</template>

<script>
import MallFloatNavigator from '../components/FloatNavigator';
import MallBanner from '../components/Banner';
import addToken from '../libs/add-token';
import MallDiscButton from '../components/DiscButton';
import MallNoticeDialog from '../components/NoticeDialog';
import localStorage from '../local-storage';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

export default {
  name: 'Home',

  components: {
    MallFloatNavigator,
    MallBanner,
    MallNoticeDialog,
    MallDiscButton
  },

  filters: {
    formatTime(timestamp) {
      if (timestamp) {
        if (typeof timestamp === 'string') {
          timestamp = parseInt(timestamp);
        }
        const time = new Date(timestamp);
        let min = Math.floor(time.getMinutes());
        let sec = Math.floor(time.getSeconds());
        min = min < 10 ? '0' + min : min;
        sec = sec < 10 ? '0' + sec : sec;
        return min + ':' + sec;
      }
      else {
        return '00:00'
      }
    }
  },

  data() {
    return {
      detail: {},
      marketPlayingIndex: -1,
      playerSource: '',
      isLoading: false,

      postProductionIndex: 0,
      postPlayingIndex: -1,

      showNotice: false
    };
  },

  computed: {
    isLogin() {
      return this.$curuserid && this.$token;
    }
  },

  created() {
    this.refresh();
    this.setNewUser();

    const showNotice = localStorage.getItem('changba-music-mall-show-notice-20210204');

    if (showNotice !== 'yes' && dayjs().isBetween('2021-02-10 00:00:00', '2021-02-19 00:00:00')) {
      this.showNotice = true;
    }
  },

  activated() {
    this.$refs.board?.swipeTo(this.postProductionIndex, { immediate: true });
  },

  deactivated() {
    this.stop();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getmusichomepage');

      this.isLoading = false;
      this.$toast.clear();

      if (code === 1) {
        this.detail = data;
      }
    },

    // 为后端做的打点，前端无实际用途
    setNewUser() {
      this.$fetch('/api/musicService/musicmall/addNewUser', {
        method: 'POST',
        data: {
          versionnum: this.$route.query?.version
        }
      });
    },

    handlePlay(index, src) {
      this.playerSource = src;
      this.postPlayingIndex = -1;

      this.$nextTick(() => {
        if (this.marketPlayingIndex === index) {
          this.$refs.player.pause();
          this.marketPlayingIndex = -1;
        }
        else {
          this.marketPlayingIndex = index;
          this.$refs.player.play();
        }
      });
    },

    stop() {
      this.$refs?.player?.pause();
      this.marketPlayingIndex = -1;
      this.postPlayingIndex = -1;
    },

    changePostProduction(index) {
      this.postProductionIndex = index;
      this.$refs.board.swipeTo(index);

      if (this.postPlayingIndex >= 0) {
        // 正在播放
        //const currentTime = this.$refs.player.currentTime;

        this.$refs.player.pause();

        this.playerSource = this.detail.disc_tab[index].audio;

        this.$nextTick(() => {
          this.postPlayingIndex = index;
          this.$refs.player.play();
          // this.$refs.player.addEventListener('canplaythrough', () => {
          //   this.$refs.player.currentTime = currentTime;
          //   this.$refs.player.play();
          // }, { once: true });

          // this.$refs.player.load();
        });
      }
    },

    handlePostProductionPlay(index, audio) {
      this.playerSource = audio;
      this.marketPlayingIndex = -1;

      this.$nextTick(() => {
        if (this.postPlayingIndex === index) {
          this.$refs.player.pause();
          this.postPlayingIndex = -1;
        }
        else {
          this.postPlayingIndex = index;
          this.$refs.player.play();
        }
      });
    },

    gotoUrl(url) {
      url = url.trim();

      if (!url) {
        return;
      }

      if (url.indexOf('/') === 0) {
        url = `${window.location.origin}${url}`;
      }

      this.stop();

      if (this.$refs.navigator.isMusicboardHome()) {
        url = this.$refs.navigator.setMusicboardUrlParam(url, 'yes');

        // 本 if 语句只对开发和调试有意义
        if (/^https?:\/\/\S+\.changbaops\.com(?:$|\/)/.test(url)) {
          url = addToken(url);
        }

        window.location = `changba://?ac=webview&notfinish=yes&customurl=${encodeURIComponent(window.btoa(url))}`;
      }
      else {
        url = this.$refs.navigator.setMusicboardUrlParam(url, 'no');

        window.location = addToken(url);
      }
    },

    refreshPage() {
      if (this.$refs.navigator.isMusicboard) {
        window.location.reload();
      }
      else {
        this.refresh();
      }
    },

    closeNotice() {
      localStorage.setItem('changba-music-mall-show-notice-20210204', 'yes');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/home.scss";
</style>
